// src/components/register/RegistrationWizard/Steps/EducationalForms/ElevenTwelfthForm.js
import React, { useState, useEffect } from "react";
import Dropdown from "../../../../Usables/Dropdown/Dropdown";
import MultiSelectDropdown from "../../../../Usables/MultiSelectDropdown";
import FloatInputField from "../../../../Usables/FloatInputField";
import CurrentClass from "../../../../options/CurrentClass1011";
import SchoolBoard from "../../../../options/schoolBoard";
import Olympiads from "../../../../options/Olympiads";
import Budget from "../../../../options/Budget";
import Aggregate from "../../../../options/Aggregate";
import Best from "../../../../options/Best";
import Streams from "../../../../options/Streams";
import FutureDegree from "../../../../options/FutureDegree";
import OlympiadsTypes11_12th from "../../../../options/OlympiadTypes11_12th";
import BachelorsExam from "../../../../userForms/Bachelors/BachelorsExam";

const ElevenTwelfthForm = ({ onChange, data = {} }) => {
  // Form state
  const [currentclass, setCurrentClass] = useState(data.currentclass || "");
  const [currentstream, setCurrentStream] = useState(data.currentstream || "");
  const [schoolBoard, setSchoolBoard] = useState(data.schoolBoard || "");
  const [class10thboard, setClass10thBoard] = useState(data.class10thboard || "");
  const [class10percent, setClass10Percent] = useState(data.class10percent || "");
  const [tenthschoolname, setTenthSchoolName] = useState(data.tenthschoolname || "");
  const [schoolname, setSchoolName] = useState(data.schoolname || "");
  const [bestOfFive, setBestOfFive] = useState(data.BestOfFive || "");
  const [aggregatepercent, setAggregatePercent] = useState(data.aggregatepercent || "");
  const [olympiadparticipated, setOlympiadParticipated] = useState(
    data.olympiadparticipated ? JSON.parse(data.olympiadparticipated) : []
  );
  const [olympiadinterested, setOlympiadInterested] = useState(
    data.olympiadinterested ? JSON.parse(data.olympiadinterested) : []
  );
  const [futureolympiadtypes, setFutureOlympiadTypes] = useState(
    data.futureolympiadtypes ? JSON.parse(data.futureolympiadtypes) : []
  );
  const [futuredegree, setFutureDegree] = useState(data.futuredegree || "");
  const [budget, setBudget] = useState(data.budget || "");
  const [error, setError] = useState(null);
  const [exams, setExams] = useState(data.exams ? JSON.parse(data.exams) : [
    {
      type: "text",
      id: 1,
      name: "",
      date: "",
      percentage: "",
      criteria: "100 %",
    },
  ]);

  // Update parent component whenever form data changes
  useEffect(() => {
    onChange({
      currentclass,
      currentstream,
      schoolBoard,
      class10thboard,
      class10percent,
      tenthschoolname,
      schoolname,
      BestOfFive: bestOfFive,
      aggregatepercent,
      olympiadparticipated: JSON.stringify(getValuesArray(olympiadparticipated)),
      olympiadinterested: JSON.stringify(getValuesArray(olympiadinterested)),
      futureolympiadtypes: JSON.stringify(getValuesArray(futureolympiadtypes)),
      futuredegree,
      budget,
      exams: JSON.stringify(exams)
    });
  }, [
    currentclass, currentstream, schoolBoard, class10thboard, class10percent,
    tenthschoolname, schoolname, bestOfFive, aggregatepercent, olympiadparticipated,
    olympiadinterested, futureolympiadtypes, futuredegree, budget, exams
  ]);

  // Helper function to extract values from multi-select options
  const getValuesArray = (options) => {
    if (!options || options.length === 0) return [];
    return options.map(option => option.value);
  };

  const handleCurrentClass = (e) => {
    setCurrentClass(e.value);
  };

  const handleCurrentStream = (e) => {
    setCurrentStream(e.value);
  };

  const handleSchoolBoard = (e) => {
    setSchoolBoard(e.value);
  };

  const handleClass10thBoard = (e) => {
    setClass10thBoard(e.value);
  };

  const handleClass10Percent = (event) => {
    const value = event.target.value;
    if (value !== "" && isNaN(value)) {
      setError("* Please enter a valid number between 0 and 100");
    } else if (value < 0 || value > 100) {
      setError("* Please enter a number between 0 and 100");
    } else {
      setError(null);
    }
    setClass10Percent(value);
  };

  const handleTenthSchoolName = (event) => {
    setTenthSchoolName(event.target.value);
  };

  const handleSchoolName = (event) => {
    setSchoolName(event.target.value);
  };

  const handleBestOfFive = (e) => {
    setBestOfFive(e.value);
  };

  const handleAggregatePercent = (e) => {
    setAggregatePercent(e.value);
  };

  const handleOlympiadParticipated = (options) => {
    setOlympiadParticipated(options);
  };

  const handleOlympiadInterested = (options) => {
    setOlympiadInterested(options);
  };

  const handleFutureOlympiadTypes = (options) => {
    setFutureOlympiadTypes(options);
  };

  const handleFutureDegree = (e) => {
    setFutureDegree(e.value);
  };

  const handleBudget = (e) => {
    setBudget(e.value);
  };

  return (
    <div className="educational-form-content">
      <div className="form-section">
        <Dropdown
          name="streams"
          value={currentstream}
          options={Streams}
          placeHolder="Current Stream"
          onChange={handleCurrentStream}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="class"
          value={currentclass}
          options={CurrentClass}
          placeHolder="Current Class"
          onChange={handleCurrentClass}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="schoolboard"
          value={schoolBoard}
          options={SchoolBoard}
          placeHolder="School Board"
          onChange={handleSchoolBoard}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="tenthBoard"
          value={class10thboard}
          options={SchoolBoard}
          placeHolder="Tenth Board"
          onChange={handleClass10thBoard}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="TenthPercentage"
          placeHolder="Tenth Percentage"
          handleInput={handleClass10Percent}
          err={error}
          inputVal={class10percent}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="TenthSchoolName"
          placeHolder="10th School Name"
          handleInput={handleTenthSchoolName}
          inputVal={tenthschoolname}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="SchoolName"
          placeHolder="Current School Name"
          handleInput={handleSchoolName}
          inputVal={schoolname}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="BestOfFive"
          value={bestOfFive}
          options={Best}
          placeHolder="Best of 5 marks"
          onChange={handleBestOfFive}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="Aggregate"
          value={aggregatepercent}
          options={Aggregate}
          placeHolder="Aggregate Percentage"
          onChange={handleAggregatePercent}
        />
      </div>
      
      <div className="form-section exams-section">
        <BachelorsExam exams={exams} setExams={setExams} />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={Olympiads}
          onSelect={handleOlympiadParticipated}
          value={olympiadparticipated}
          placeholderDropdown="Olympiads Participated"
          placeholderInput="Search for olympiads"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={Olympiads}
          onSelect={handleOlympiadInterested}
          value={olympiadinterested}
          placeholderDropdown="Olympiads Interested in future"
          placeholderInput="Search for olympiads"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="futureDegree"
          value={futuredegree}
          options={FutureDegree}
          placeHolder="Future Degree"
          onChange={handleFutureDegree}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="budget"
          value={budget}
          options={Budget}
          placeHolder="Budget in INR"
          onChange={handleBudget}
        />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={OlympiadsTypes11_12th}
          onSelect={handleFutureOlympiadTypes}
          value={futureolympiadtypes}
          placeholderDropdown="Olympiads type Interested in future"
          placeholderInput="Search for your category"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
    </div>
  );
};

export default ElevenTwelfthForm;